/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerGCSCommonData.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for GCS Common Data
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, April 01, 2019 - 7:15 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      04/01/2019  NJN     File Created
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    ASSET_SET_GROUP_SELECT,
    ASSET_LIST_COMPLETE,
} from '../constants/actionTypeAssets';

const defaultState = {
    refreshList: false,
    assetListsLoaded: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ASSET_SET_GROUP_SELECT:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case ASSET_LIST_COMPLETE:
            return {
                ...state,
                assetListsLoaded: true
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerGCSCommonData.js